document.addEventListener('readystatechange', function(e) {

  if (document.readyState !== 'complete') {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.size > 0) {
    return;
  }
  const areaData = decodeURIComponent(urlParams.get('area')); // URLのパラメータからエリアを取得　ここは、御菓印ページの時は、ないからnull
  const id = decodeURIComponent(urlParams.get('id'));

  // エリアデータがある場合
  if (areaData) {
    const currentActive = document.querySelector('.shopAreaList .area__item.active');
    const items = document.querySelectorAll('.shopAreaList .area__item');

    if (currentActive) {
      currentActive.classList.remove('active');  // 現在のアクティブを削除
    }
    items.forEach(item => {
      if (item.innerText === areaData) {
        item.click();  // 該当エリアがあればクリック
      }
    });
  }

  // IDがある場合
  if (id) {
    const activeItem = document.querySelector(`.shopDetailItem[id="${id}"]`);
    const currentActive = document.querySelector('.gokainAreaList .area__item.active');
    if (currentActive) {
      currentActive.classList.remove('active');
    }
    const newActive = document.querySelector(`.flexBlock.shopDetailItem[id="${id}"]`);

    if (newActive) {
      const area = newActive.getAttribute('data-area');
      const items = document.querySelectorAll('.gokainAreaList .area__item');
      let clickedItem = null;
      items.forEach(item => {
        if (item.innerText === area) {
          clickedItem = item;
        }
      });
      if (clickedItem) {
        clickedItem.click();
        newActive.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
});
